//# sourceMappingURL=svg.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/svg.interface.js
// module id = 1184
// module chunks = 4